export default __webpack_public_path__ + "static/media/DROP_DOWN.ef525fad.svg";